import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserI } from '../../interfaces/user.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() userData: UserI = null as any;
  @Input() smallScreen: boolean = false;
  @Input() currentLang: string = 'en';

  userInitial: string = '';
  userFirstName: string = '';

  /** Mobile drawer open state */
  isOpen: boolean = false;

  // Admin email for support chat access
  private readonly ADMIN_EMAIL = 'speedparadigm@gmail.com';

  constructor(
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.updateUserDisplay();

    // Close the mobile drawer whenever navigation completes
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this.close());
  }

  ngOnChanges() {
    this.updateUserDisplay();
  }

  updateUserDisplay() {
    if (this.userData && this.userData.name) {
      this.userInitial = this.userData.name.charAt(0).toUpperCase();
      const nameParts = this.userData.name.trim().split(' ');
      this.userFirstName = nameParts[0];
    } else if (this.userData?.email) {
      this.userInitial = this.userData.email.charAt(0).toUpperCase();
    }
  }

  isActive(route: string): boolean {
    return this.router.url === route || this.router.url.startsWith(route + '/');
  }

  get isAdmin(): boolean {
    return this.userData?.email === this.ADMIN_EMAIL;
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.isOpen) this.close();
  }

  setLanguage(lang: string) {
    this.currentLang = lang;
    this.translate.use(lang);
    localStorage.setItem('selectedLang', lang);
  }

  onLanguageChange(event: any) {
    this.setLanguage(event.target.value);
  }
}
